import React, { useState } from 'react'
import dayjs from 'dayjs'
import { Box, useTheme } from '@mui/material'

const DateField = (props: any) => {
  const { name, label, value, update } = props
  const [date, setDate] = useState(value && dayjs(value).isValid() ? dayjs(value).format('MM/DD/YYYY') : '')
  const [isValidFormat, setIsValidFormat] = useState(true)
  const theme = useTheme()

  const handleChange = (event: any) => {
    const inputDate = event.target.value
    // Validate the input date format using Day.js
    setDate(inputDate)
    let hasError = false
    if (dayjs(inputDate, 'MM/DD/YYYY').isValid()) {
      setIsValidFormat(true)
    } else {
      hasError = true
      setIsValidFormat(false)
    }
    update(name, inputDate, hasError)
  }

  return (
    <div style={{width: '100%'}}>
      { label ? 
      <label htmlFor={`date_${name}`}>{label} (MM-DD-YYYY):</label>
      : null }
      <Box
        sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: theme.spacing(0.85, 1, 0.85, 1.6),
            border: '1px solid #E5E3EA',
            mt: 1,
            mb: 1,
        }}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'center'}>
        <input
            type="text"
            id={`date_${name}`}
            value={date}
            placeholder="MM/DD/YYYY"
            onChange={handleChange}
            style={{
                width: '100%',
                border: 0,
                outline: 0,
                fontSize: '1em'
            }}
        />
      </Box>
      {!isValidFormat && (
        <div style={{ color: 'red', fontSize: '.9em' }}>Enter valid date format (MM/DD/YYYY).</div>
      )}
    </div>
  )
}

export default DateField
